export const PRIMARY_COLOR = ["#004990", "#336da6"];
export const PRIMARY_COLOR_LIGHTER = ["rgba(51,109,166, 0.3)"]
export const SECONDARY_COLOR = "#5DEB41";
export const SECONDARY_COLOR_DARKER = "#22880e";
export const WARNING_COLOR = ["#FFC107", "#b28704", "#ffcd38"];
export const DANGER_COLOR = ["#ed1c23", "#a51318", "#f0494f"];
export const SUCCESS_COLOR = ["#4caf50", "#4caf50", "#6fbf73"];
export const INFO_COLOR = ["#2196f3", "#1976d2"];
export const BLACK_COLOR = "#000";
export const WHITE_COLOR = "#FFF";
export const GREY_COLOR = "#dedede";
export const ORANGE_COLOR = "#FF8300";
export const LIGHT_GREY_COLOR = "#F8F8F8"


